import { Hours } from '../../domain/shared/hours';
import { Money } from '../../domain/shared/money';

/**
 * Rehidratação de objetos de valor na fronteira HTTP.
 *
 * `Money` e `Hours` são classes com método (`.format()`, `.toUnits()`), e JSON não carrega
 * método: do outro lado `Money` viraria `{ cents }` e a tela quebraria ao chamar `.format()`.
 * O servidor os etiqueta ao serializar a resposta e o cliente os reconstrói ao lê-la — o
 * domínio e o armazenamento seguem intactos, a conversão vive só no transporte.
 *
 * A etiqueta (`__vo`) só é posta pelo `replacer` sobre instâncias de verdade, então um dado
 * comum nunca é confundido com um objeto de valor na volta.
 */

const TAG = '__vo';

/** Para `JSON.stringify(body, valueObjectReplacer)` no adaptador do servidor. */
export function valueObjectReplacer(_key: string, value: unknown): unknown {
  if (value instanceof Money) return { [TAG]: 'Money', cents: value.cents };
  if (value instanceof Hours) return { [TAG]: 'Hours', quarters: value.quarters };
  return value;
}

/** Para `JSON.parse(text, valueObjectReviver)` no cliente HTTP. */
export function valueObjectReviver(_key: string, value: unknown): unknown {
  if (value === null || typeof value !== 'object' || !(TAG in value)) return value;
  const marcado = value as Record<string, unknown>;
  if (marcado[TAG] === 'Money') {
    const reconstruido = Money.fromCents(Number(marcado['cents']));
    if (reconstruido.ok) return reconstruido.value;
  }
  if (marcado[TAG] === 'Hours') {
    const reconstruido = Hours.fromQuarters(Number(marcado['quarters']));
    if (reconstruido.ok) return reconstruido.value;
  }
  return value;
}
